/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from "react";
import "../css/campaignListcss.css";
import "../css/lineclamp2css.css";
import { Modal } from "./ui";
import Swal from "sweetalert2";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import ScrollToTopButton from "./ScrollToTopButton";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { CmsService } from "../services/cmsService";
import formErrorPopupInstance from "../utils/formValidation.js";
import { Icon } from "./ui";

function Communication(props) {
  const { t, i18n } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [editIsOpen, setEditIsOpen] = useState(false);
  const [endDate, setEndDate] = useState("");
  const [Page, setPage] = useState();
  const [startDate, setStartDate] = useState("");
  const [isPin, setIsPin] = useState("");
  const [contentEngName, setContentEngName] = useState("");
  const [contentChiName, setContentChiName] = useState("");
  const [contentSimName, setContentSimName] = useState("");
  const [communication, setCommunication] = useState([]);
  const [communcationId, setCommuncationId] = useState("");
  const [preResult, setPreResult] = useState();
  const [nextResult, setNextResult] = useState();
  const [pagination, setPagination] = useState({});
  const [selectedValue, setSelectedValue] = useState("10");
  const [isFormValid, setIsFormValid] = useState(true); // Initialize to true
  const [isMobileScreen, setIsMobileScreen] = useState(
    window.innerWidth <= 1250 ? true : false
  );
  // const [isXsMobileScreen, setXsIsMobileScreen] = useState(((window.screen.width<= 385)?true:false));
  const [postData, setPostData] = useState({
    pageableParameter: {
      pageNumber: 0,
      pageSize: 10,
      orderBy: "latestUpdate",
      orderSequence: "desc",
    },
  });

  useEffect(() => {
    const savedLanguage = Cookies.get("language");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  useEffect(() => {
    function handleResize() {
      setIsMobileScreen(window.innerWidth <= 1250);
      // setXsIsMobileScreen(window.screen.width<= 385);
    }

    handleResize();
    window.addEventListener("resize", handleResize);

    // Add this block to update isMobileScreen when the screen size is larger than 1207 pixels
    return () => {
      window.removeEventListener("resize", handleResize);
      setIsMobileScreen(false);
      // setXsIsMobileScreen(false);
    };
  }, []);

  useEffect(() => {
    var cmsService = new CmsService();
    cmsService
      .retrieveCommunications(
        postData.pageableParameter.pageNumber,
        postData.pageableParameter.pageSize
      )
      .then((response) => {
        return response.data;
      })
      .then((data) => {
        setCommunication(data.tcmsBrokerCommunicationEntityList);
        setPagination(data.pagination);

        const pageNumber = parseInt(data.pagination.pageNumber);
        const pageSize = parseInt(data.pagination.pageSize);
        const totalPages = parseInt(data.pagination.totalPages);
        const totalNumberOfRecords = parseInt(
          data.pagination.totalNumberOfRecords
        );
        if (pageNumber === 0) {
          setPreResult(1);
          setNextResult(pageSize);
        } else {
          setPreResult(pageNumber * pageSize + 1);
          setNextResult((pageNumber + 1) * pageSize);
        }

        if (data.pagination.hasNext === "false" && pageNumber !== 0) {
          setPreResult((totalPages - 1) * pageSize + 1);
          setNextResult(totalNumberOfRecords);
        }
      })
      .catch((error) => console.error(error));
  }, [postData, selectedValue, Page]);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const openEdit = (data) => {
    const startDate = new Date(data.startDate);
    const endDate = new Date(data.endDate);
    const formattedStartDate = startDate.toISOString().slice(0, 10);
    const formattedEndDate = endDate.toISOString().slice(0, 10);
    setCommuncationId(data.communicationId);
    setIsPin(data.isPin);
    setContentChiName(data.communicationNameHk);
    setContentEngName(data.communicationNameEng);
    setContentSimName(data.communicationNameCn);
    setStartDate(formattedStartDate);
    setEndDate(formattedEndDate);
    setEditIsOpen(true);
  };

  const closeEdit = () => {
    setEditIsOpen(false);
    setIsPin("N");
    setContentChiName("");
    setContentEngName("");
    setContentSimName("");
    setStartDate("");
    setEndDate("");
  };

  const showEditMobile = (data) => {
    const startDate = new Date(data.startDate);
    const endDate = new Date(data.endDate);
    const formattedStartDate = startDate.toISOString().slice(0, 10);
    const formattedEndDate = endDate.toISOString().slice(0, 10);
    setCommuncationId(data.communicationId);
    setIsPin(data.isPin);
    setContentChiName(data.communicationNameHk);
    setContentEngName(data.communicationNameEng);
    setContentSimName(data.communicationNameCn);
    setStartDate(formattedStartDate);
    setEndDate(formattedEndDate);
    setShowEditModal(true);
  };

  const closeEditMobile = () => {
    setShowEditModal(false);
    setIsPin("N");
    setContentChiName("");
    setContentEngName("");
    setContentSimName("");
    setStartDate("");
    setEndDate("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission

    if (contentEngName === "") {
      formErrorPopupInstance.addError(
        t("cms.brokersCommunications.contentEng")
      );
    }

    if (contentChiName === "") {
      formErrorPopupInstance.addError(t("cms.brokersCommunications.contentHk"));
    }

    if (contentSimName === "") {
      formErrorPopupInstance.addError(t("cms.brokersCommunications.contentCn"));
    }

    if (!isFormValid || startDate === "" || endDate === "") {
      formErrorPopupInstance.addError(t("errors.invalidDateRange"));
    }

    formErrorPopupInstance.showErrors();

    if (formErrorPopupInstance.errors.length === 0) {
      var cmsService = new CmsService();
      e.preventDefault();
      cmsService
        .retrieveCommunication(
          0,
          "create",
          contentEngName.trim(),
          contentChiName.trim(),
          contentSimName.trim(),
          isPin,
          startDate,
          endDate
        )
        .then((value) => {
          console.log(value);
          if (value.status === 200) {
            closeModal();
            Swal.fire({
              icon: "success",
              title: t("cms.brokersCommunications.created"),
              showConfirmButton: false,
              timer: 1700,
            }).then(function () {
              window.location = "/BrokerCom";
            });
          }
        });
    }
    formErrorPopupInstance.clearErrors();
  };

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    setPostData({
      pageableParameter: {
        pageNumber: 0,
        pageSize: event.target.value,
        orderBy: "latestUpdate",
        orderSequence: "desc",
      },
    });
  };

  const handlePageChange = (event) => {
    setPage(event);
    setPostData({
      pageableParameter: {
        pageNumber: event - 1,
        pageSize: pagination.pageSize,
        orderBy: "latestUpdate",
        orderSequence: "desc",
      },
    });
  };

  const handleEdit = async (e) => {
    e.preventDefault(); // Prevent default form submission
    if (contentEngName === "") {
      formErrorPopupInstance.addError(
        t("cms.brokersCommunications.contentEng")
      );
    }

    if (contentChiName === "") {
      formErrorPopupInstance.addError(t("cms.brokersCommunications.contentHk"));
    }

    if (contentSimName === "") {
      formErrorPopupInstance.addError(t("cms.brokersCommunications.contentCn"));
    }

    if (!isFormValid || startDate === "" || endDate === "") {
      formErrorPopupInstance.addError(t("errors.invalidDateRange"));
    }

    formErrorPopupInstance.showErrors();

    if (formErrorPopupInstance.errors.length === 0) {
      var cmsService = new CmsService();
      e.preventDefault();
      cmsService
        .retrieveCommunication(
          communcationId,
          "edit",
          contentEngName.trim(),
          contentChiName.trim(),
          contentSimName.trim(),
          isPin,
          startDate,
          endDate
        )
        .then((value) => {
          if (value.status === 200) {
            closeEdit();
            Swal.fire({
              icon: "success",
              title: t("cms.brokersCommunications.updated"),
              showConfirmButton: false,
              timer: 1700,
            }).then(function () {
              window.location = "/BrokerCom";
            });
          }
        });
    }
    formErrorPopupInstance.clearErrors();
  };

  const handleDelete = async (communicationId) => {
    // Show a confirmation dialog before deleting the URL
    const result = await Swal.fire({
      icon: "warning",
      title: t("common.deleteConfirmText"),
      showCancelButton: true,
      confirmButtonColor: "#dc3545", // set confirm button color to red
      confirmButtonText: t("common.delete"),
      cancelButtonText: t("common.cancel"),
    });

    // Check if the user clicked the delete button
    if (result.isConfirmed) {
      var cmsService = new CmsService();
      cmsService
        .retrieveCommunication(
          communicationId,
          "delete",
          contentEngName,
          contentChiName,
          contentSimName,
          isPin,
          startDate,
          endDate
        )
        .then((value) => {
          if (value.status === 200) {
            // Reload the page to show the updated list of links
            window.location.reload();
          } else {
            // Handle error
            console.error("Error deleting item");
          }
        });
    }
  };

  const showCreateMobile = () => {
    setShowModal(true);
  };

  const closeCreateMobile = () => {
    setShowModal(false);
  };

  const handleStartDateChange = (e) => {
    const newStartDate = e.target.value;
    setStartDate(newStartDate);
    if (endDate && newStartDate > endDate) {
      setIsFormValid(false);
    } else {
      setIsFormValid(true);
    }
  };

  const handleEndDateChange = (e) => {
    const newEndDate = e.target.value;
    setEndDate(newEndDate);
    if (startDate && newEndDate < startDate) {
      setIsFormValid(false);
    } else {
      setIsFormValid(true);
    }
  };

  return (
    <>
      {isMobileScreen ? (
        <div className="w-full">
          <div className="flex">
            <h1 className="text-header font-bold w-3/4 mt-2 text-ft-light">
              {t("cms.brokersCommunications")}
            </h1>
            <a
              onClick={() => showCreateMobile()}
              className="w-1/4 text-tableHeader bg-ft-light text-center text-white py-2 px-3 rounded hover:bg-ft active:bg-white active:text-ft active:ring-1 active:ring-ft">
              {t("common.create")}
            </a>
          </div>

          <div className="mt-2 ">
            <p className="text-content">
              {t("common.showPerPage1")}
              <select
                id="countries"
                aria-label="Select page size"
                className="mx-2 w-20 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-ft-light focus:border-ft-light p-2.5"
                value={selectedValue}
                onChange={handleChange}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              {t("common.showPerPage2")}
            </p>
          </div>

          {showModal ? (
            <>
              <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative w-5/6 my-6 mx-auto max-w-3xl">
                  {/*content*/}
                  <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none p-5">
                    <form onSubmit={handleSubmit}>
                      <div className="w-auto flex-col min-w-link">
                        <div className="flex">
                          <div className="w-1/2 mr-5">
                            <label htmlFor="startDate">
                              {t("common.startDate")}
                              <span className="text-red-600">*</span>:
                            </label>
                            <input
                              type="date"
                              id="startDate"
                              value={startDate}
                              className="w-full ring-ft-light focus:border-0 border-gray-500"
                              onChange={handleStartDateChange}
                            />
                          </div>
                          <div className="w-1/2">
                            <label htmlFor="endDate">
                              {t("common.endDate")}
                              <span className="text-red-600">*</span>:
                            </label>
                            <input
                              type="date"
                              id="endDate"
                              value={endDate}
                              className="w-full ring-ft-light focus:border-0 border-gray-500"
                              onChange={handleEndDateChange}
                            />
                          </div>
                        </div>
                        <div className="mt-3">
                          <label htmlFor="contentEngName">
                            {t("cms.brokersCommunications.contentEng")}
                            <span className="text-red-600">*</span>:
                          </label>
                          <input
                            type="text"
                            id="contentEngName"
                            value={contentEngName}
                            className="w-full ring-ft-light focus:border-0 border-gray-500"
                            onChange={(e) => setContentEngName(e.target.value)}
                          />
                        </div>
                        <div className="mt-3">
                          <label htmlFor="contentChiName">
                            {t("cms.brokersCommunications.contentHk")}
                            <span className="text-red-600">*</span>:
                          </label>
                          <input
                            type="text"
                            id="contentChiName"
                            value={contentChiName}
                            className="w-full ring-ft-light focus:border-0 border-gray-500"
                            onChange={(e) => setContentChiName(e.target.value)}
                          />
                        </div>
                        <div className="mt-3">
                          <label htmlFor="contentSimName">
                            {t("cms.brokersCommunications.contentCn")}
                            <span className="text-red-600">*</span>:
                          </label>
                          <input
                            type="text"
                            id="contentSimName"
                            value={contentSimName}
                            className="w-full ring-ft-light focus:border-0 border-gray-500"
                            onChange={(e) => setContentSimName(e.target.value)}
                          />
                        </div>
                        <div className="mt-3">
                          <label className="mr-2" htmlFor="isPin">
                            {t("cms.brokersCommunications.pin")}:
                          </label>
                          <input
                            type="checkbox"
                            id="isPin"
                            value={isPin}
                            className="text-black ring-0"
                            checked={isPin === "Y"}
                            onChange={(e) =>
                              setIsPin(e.target.checked ? "Y" : "N")
                            }
                          />
                        </div>
                      </div>
                      <div className="w-auto max-w-96 flex mt-4">
                        <button
                          type="submit"
                          className="w-1/2 mr-5 px-3 py-2 ring-ft-light bg-ft-light text-white rounded ring-1 active:bg-ft active:ring-ft">
                          {t("common.create")}
                        </button>
                        <button
                          type="button"
                          className="w-1/2 rounded px-3 py-2 ring-1 ring-ft-light"
                          onClick={() => closeCreateMobile()}>
                          {t("common.cancel")}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </>
          ) : null}

          {showEditModal ? (
            <>
              <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative w-5/6 my-6 mx-auto max-w-3xl">
                  {/*content*/}
                  <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none p-5">
                    <form onSubmit={handleEdit}>
                      <div className=" flex-col">
                        <div className="flex">
                          <div className="w-1/2 mr-5 ">
                            <label htmlFor="startDate ">
                              {t("common.startDate")}
                              <span className="text-red-600">*</span>:
                            </label>
                            <input
                              type="date"
                              id="startDate"
                              value={startDate}
                              className="w-full ring-ft-light focus:border-0 border-gray-500"
                              onChange={handleStartDateChange}
                            />
                          </div>
                          <div className="w-1/2">
                            <label htmlFor="endDate">
                              {t("common.endDate")}
                              <span className="text-red-600">*</span>:
                            </label>
                            <input
                              type="date"
                              id="endDate"
                              value={endDate}
                              className="w-full ring-ft-light focus:border-0 border-gray-500"
                              onChange={handleEndDateChange}
                            />
                          </div>
                        </div>
                        <div className="mt-3">
                          <label htmlFor="contentEngName">
                            {t("cms.brokersCommunications.contentEng")}
                            <span className="text-red-600">*</span>:
                          </label>
                          <input
                            type="text"
                            id="contentEngName"
                            value={contentEngName}
                            className="w-full ring-ft-light focus:border-0 border-gray-500"
                            onChange={(e) => setContentEngName(e.target.value)}
                          />
                        </div>
                        <div className="mt-3">
                          <label htmlFor="contentChiName">
                            {t("cms.brokersCommunications.contentHk")}
                            <span className="text-red-600">*</span>:
                          </label>
                          <input
                            type="text"
                            id="contentChiName"
                            value={contentChiName}
                            className="w-full ring-ft-light focus:border-0 border-gray-500"
                            onChange={(e) => setContentChiName(e.target.value)}
                          />
                        </div>
                        <div className="mt-3">
                          <label htmlFor="contentSimName">
                            {t("cms.brokersCommunications.contentCn")}
                            <span className="text-red-600">*</span>:
                          </label>
                          <input
                            type="text"
                            id="contentSimName"
                            value={contentSimName}
                            className="w-full ring-ft-light focus:border-0 border-gray-500"
                            onChange={(e) => setContentSimName(e.target.value)}
                          />
                        </div>
                        <div className="mt-3">
                          <label className="mr-2" htmlFor="isPin">
                            {t("cms.brokersCommunications.pin")}:
                          </label>
                          <input
                            type="checkbox"
                            id="isPin"
                            value={isPin}
                            className="text-black ring-0"
                            checked={isPin === "Y"}
                            onChange={(e) =>
                              setIsPin(e.target.checked ? "Y" : "N")
                            }
                          />
                        </div>
                      </div>
                      <div className="w-auto max-w-96 flex mt-4">
                        <button
                          type="submit"
                          className="w-1/2 mr-5 px-3 py-2 ring-ft-light bg-ft-light text-white rounded ring-1 active:bg-ft active:ring-ft">
                          {t("common.save")}
                        </button>
                        <button
                          type="button"
                          className="w-1/2 rounded px-3 py-2 ring-1 ring-ft-light"
                          onClick={() => closeEditMobile()}>
                          {t("common.cancel")}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </>
          ) : null}
          <div className="flex">
            <table className=" flex w-full bg-white">
              <thead className="sm:w-1/5 w-2/5 text-white">
                {communication || communication.length !== 0
                  ? communication.map((campaignMobileHead) => {
                      return (
                        <tr
                          className="pl-1 bg-ft-light flex flex-col mb-2 border border-slate-300"
                          key={campaignMobileHead.communicationId}>
                          <th className="text-mobileLandingContent font-bold">
                            {t("common.startDate")}
                          </th>
                          <th className="text-mobileLandingContent font-bold">
                            {t("common.endDate")}
                          </th>

                          <th className="text-mobileLandingContent font-bold ">
                            {t("cms.brokersCommunications.contentEng")}
                          </th>
                          <th className="text-mobileLandingContent font-bold">
                            {t("cms.brokersCommunications.contentHk")}
                          </th>
                          <th className="text-mobileLandingContent font-bold">
                            {t("cms.brokersCommunications.contentCn")}
                          </th>
                          <th className="text-mobileLandingContent font-bold">
                            {t("cms.brokersCommunications.pin")}
                          </th>
                          <th className="text-mobileLandingContent font-bold mb-">
                            {t("common.edit")}
                          </th>
                          <th className="text-mobileLandingContent font-bold mb-cmsmobile">
                            {t("common.delete")}
                          </th>
                        </tr>
                      );
                    })
                  : ""}
              </thead>
              <tbody className="sm:w-4/5 w-3/5 ">
                {communication.map((campaign) => {
                  const startDate = new Date(campaign.startDate);
                  const endDate = new Date(campaign.endDate);
                  const formattedStartDate = startDate
                    .toISOString()
                    .slice(0, 10);
                  const formattedEndDate = endDate.toISOString().slice(0, 10);

                  return (
                    <tr
                      className="flex flex-col border border-slate-300 mb-2"
                      key={campaign.communicationId}>
                      <td className="pl-3 pr-3  text-mobileLandingContent ">
                        {formattedStartDate}
                      </td>
                      <td className="pl-3 pr-3  text-mobileLandingContent">
                        {formattedEndDate}
                      </td>
                      <td className="pl-3 pr-3  w-5/6 truncate text-mobileLandingContent">
                        {campaign.communicationNameEng}
                      </td>
                      <td className="pl-3 pr-3  w-5/6 truncate text-mobileLandingContent">
                        {campaign.communicationNameHk}
                      </td>
                      <td className="pl-3 pr-3  w-5/6 truncate text-mobileLandingContent">
                        {campaign.communicationNameCn}
                      </td>
                      <td className="pl-3 pr-3 text-mobileLandingContent">
                        {campaign.isPin === "Y" ? (
                          <div className="w-5.5 text-ft-light">
                            <svg
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true">
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M4.5 12.75l6 6 9-13.5"></path>
                            </svg>
                          </div>
                        ) : (
                          <div className="w-5.5 text-ft-light">
                            <svg
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="1"
                              viewBox="0 0 14 14">
                              <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                              />
                            </svg>
                          </div>
                        )}
                      </td>

                      <td className="pl-3 pr-3">
                        <a onClick={() => showEditMobile(campaign)}>
                          <Icon src="edit" color="primary" />
                        </a>
                      </td>

                      <td className="pl-3 pr-3 mb-1">
                        <a
                          onClick={() =>
                            handleDelete(campaign.communicationId)
                          }>
                          <Icon src="delete" color="primary" />
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="flex flex-col items-center">
            <div>
              {pagination.totalNumberOfRecords === 0 ? (
                <p className="text-sm text-gray-700">{t("common.noRecord")}</p>
              ) : (
                <p className="text-sm text-gray-700">
                  {t("common.showPage1")}
                  <span className="font-medium"> {preResult}</span>{" "}
                  {t("common.showPage2")}{" "}
                  <span className="font-medium">{nextResult}</span>{" "}
                  {t("common.showPage3")}{" "}
                  <span className="font-medium">
                    {pagination.totalNumberOfRecords}
                  </span>{" "}
                  {t("common.showPage4")}
                </p>
              )}
            </div>
            {pagination && pagination.totalNumberOfRecords > 0 && (
              <Stack spacing={2}>
                <Pagination
                  page={parseInt(pagination.pageNumber) + 1}
                  shape={"circular"}
                  count={
                    pagination.totalNumberOfRecords &&
                    pagination.pageSize &&
                    !isNaN(pagination.totalNumberOfRecords) &&
                    !isNaN(pagination.pageSize)
                      ? Math.ceil(
                          pagination.totalNumberOfRecords / pagination.pageSize
                        )
                      : 0
                  }
                  onChange={(e, value) => handlePageChange(value)}
                />
              </Stack>
            )}
          </div>
          <ScrollToTopButton />
        </div>
      ) : (
        <div className="w-deflaut px-2">
          <div className="flex justify-content-between align-items-center my-3">
            <p className="text-header text-ft-light font-bold">
              {t("cms.brokersCommunications")}
            </p>

            <div onClick={openModal}>
              <a
                className={
                  "text-tableHeader text-white bg-ft-light rounded px-3 py-2 cursor-pointer"
                }>
                {t("common.create")}
              </a>
            </div>

            <Modal
              open={modalIsOpen}
              onClose={closeModal}
              component="form"
              onSubmit={handleSubmit}>
              <div className=" flex-col">
                <div className="flex">
                  <div className="w-1/2 mr-5">
                    <label htmlFor="startDate">
                      {t("common.startDate")}
                      <span className="text-red-600">*</span>:
                    </label>
                    <input
                      type="date"
                      id="startDate"
                      value={startDate}
                      className="w-full ring-ft-light focus:border-0 border-gray-500"
                      onChange={handleStartDateChange}
                    />
                  </div>
                  <div className="w-1/2">
                    <label htmlFor="endDate">
                      {t("common.endDate")}
                      <span className="text-red-600">*</span>:
                    </label>
                    <input
                      type="date"
                      id="endDate"
                      value={endDate}
                      className="w-full ring-ft-light focus:border-0 border-gray-500"
                      onChange={handleEndDateChange}
                    />
                  </div>
                </div>
                <div className="mt-3">
                  <label htmlFor="contentEngName">
                    {t("cms.brokersCommunications.contentEng")}
                    <span className="text-red-600">*</span>:
                  </label>
                  <input
                    type="text"
                    id="contentEngName"
                    value={contentEngName}
                    className="w-full ring-ft-light focus:border-0 border-gray-500"
                    onChange={(e) => setContentEngName(e.target.value)}
                  />
                </div>
                <div className="mt-3">
                  <label htmlFor="contentChiName">
                    {t("cms.brokersCommunications.contentHk")}
                    <span className="text-red-600">*</span>:
                  </label>
                  <input
                    type="text"
                    id="contentChiName"
                    value={contentChiName}
                    className="w-full ring-ft-light focus:border-0 border-gray-500"
                    onChange={(e) => setContentChiName(e.target.value)}
                  />
                </div>
                <div className="mt-3">
                  <label htmlFor="contentSimName">
                    {t("cms.brokersCommunications.contentCn")}
                    <span className="text-red-600">*</span>:
                  </label>
                  <input
                    type="text"
                    id="contentSimName"
                    value={contentSimName}
                    className="w-full ring-ft-light focus:border-0 border-gray-500"
                    onChange={(e) => setContentSimName(e.target.value)}
                  />
                </div>
                <div className="mt-3">
                  <label className="mr-2" htmlFor="isPin">
                    {t("cms.brokersCommunications.pin")}:
                  </label>
                  <input
                    type="checkbox"
                    id="isPin"
                    value={isPin}
                    className="text-black ring-0"
                    checked={isPin === "Y"}
                    onChange={(e) => setIsPin(e.target.checked ? "Y" : "N")}
                  />
                </div>
              </div>
              <div className="w-auto max-w-96 flex mt-4">
                <button
                  type="submit"
                  className="w-1/2 mr-5 px-3 py-2 ring-ft-light bg-ft-light text-white rounded ring-1 active:bg-ft active:ring-ft">
                  {t("common.create")}
                </button>
                <button
                  type="button"
                  className="w-1/2 rounded px-3 py-2 ring-1 ring-ft-light"
                  onClick={closeModal}>
                  {t("common.cancel")}
                </button>
              </div>
            </Modal>
            <Modal
              open={editIsOpen}
              onClose={closeEdit}
              component="form"
              onSubmit={handleEdit}>
              <div className=" flex-col">
                <div className="flex">
                  <div className="w-1/2 mr-5">
                    <label htmlFor="startDate">
                      {t("common.startDate")}
                      <span className="text-red-600">*</span>:
                    </label>
                    <input
                      type="date"
                      id="startDate"
                      value={startDate}
                      className="w-full ring-ft-light focus:border-0 border-gray-500"
                      onChange={handleStartDateChange}
                    />
                  </div>
                  <div className="w-1/2">
                    <label htmlFor="endDate">
                      {t("common.endDate")}
                      <span className="text-red-600">*</span>:
                    </label>
                    <input
                      type="date"
                      id="endDate"
                      value={endDate}
                      className="w-full ring-ft-light focus:border-0 border-gray-500"
                      onChange={handleEndDateChange}
                    />
                  </div>
                </div>
                <div className="mt-3">
                  <label htmlFor="contentEngName">
                    {t("cms.brokersCommunications.contentEng")}
                    <span className="text-red-600">*</span>:
                  </label>
                  <input
                    type="text"
                    id="contentEngName"
                    value={contentEngName}
                    className="w-full ring-ft-light focus:border-0 border-gray-500"
                    onChange={(e) => setContentEngName(e.target.value)}
                  />
                </div>
                <div className="mt-3">
                  <label htmlFor="contentChiName">
                    {t("cms.brokersCommunications.contentHk")}
                    <span className="text-red-600">*</span>:
                  </label>
                  <input
                    type="text"
                    id="contentChiName"
                    value={contentChiName}
                    className="w-full ring-ft-light focus:border-0 border-gray-500"
                    onChange={(e) => setContentChiName(e.target.value)}
                  />
                </div>
                <div className="mt-3">
                  <label htmlFor="contentSimName">
                    {t("cms.brokersCommunications.contentCn")}
                    <span className="text-red-600">*</span>:
                  </label>
                  <input
                    type="text"
                    id="contentSimName"
                    value={contentSimName}
                    className="w-full ring-ft-light focus:border-0 border-gray-500"
                    onChange={(e) => setContentSimName(e.target.value)}
                  />
                </div>
                <div className="mt-3">
                  <label className="mr-2" htmlFor="isPin">
                    {t("cms.brokersCommunications.pin")}:
                  </label>
                  <input
                    type="checkbox"
                    id="isPin"
                    value={isPin}
                    className="text-black ring-0"
                    checked={isPin === "Y"}
                    onChange={(e) => setIsPin(e.target.checked ? "Y" : "N")}
                  />
                </div>
              </div>
              <div className="w-auto max-w-96 flex mt-4">
                <button
                  type="submit"
                  className="w-1/2 mr-5 px-3 py-2 ring-ft-light bg-ft-light text-white rounded ring-1 active:bg-ft active:ring-ft">
                  {t("common.save")}
                </button>
                <button
                  type="button"
                  className="w-1/2 rounded px-3 py-2 ring-1 ring-ft-light"
                  onClick={closeEdit}>
                  {t("common.cancel")}
                </button>
              </div>
            </Modal>
          </div>
          <div className="mr-5">
            <p className="text-content">
              {t("common.showPerPage1")}
              <select
                id="countries"
                aria-label="Select page size"
                className="mx-2 w-20 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-ft-light focus:border-ft-light p-2.5"
                value={selectedValue}
                onChange={handleChange}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              {t("common.showPerPage2")}
            </p>
          </div>
          <div className="p-2 flex align-middle justify-center">
            <div className="">
              <table className="w-full block">
                <thead className="text-tableHeader">
                  <tr className="border border-slate-300 ">
                    <th className="  pl-5 h-8">
                      <div className="inline-block  w-tableDate">
                        {t("common.startDate")}
                      </div>
                    </th>
                    <th className="  h-8 ">
                      <div className="inline-block w-tableDate">
                        {t("common.endDate")}
                      </div>
                    </th>
                    <th className="  h-8 ">
                      <div className="inline-block w-subject">
                        {t("cms.brokersCommunications.contentEng")}
                      </div>
                    </th>
                    <th className="  h-8 ">
                      <div className="inline-block w-subject">
                        {t("cms.brokersCommunications.contentHk")}
                      </div>
                    </th>
                    <th className="  h-8 ">
                      <div className="inline-block w-subject">
                        {t("cms.brokersCommunications.contentCn")}
                      </div>
                    </th>
                    <th className="  h-8 ">
                      <div className="inline-block w-linkEdit">
                        {t("cms.brokersCommunications.pin")}
                      </div>
                    </th>
                    <th className=" h-8">
                      <div className="inline-block w-linkEdit">
                        {t("common.edit")}
                      </div>
                    </th>
                    <th className=" h-8">
                      <div className="inline-block w-linkEdit mr-2">
                        {t("common.delete")}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody className="text-left text-content">
                  {communication.map((campaign) => {
                    const startDate = new Date(campaign.startDate);
                    const endDate = new Date(campaign.endDate);
                    const formattedStartDate = startDate
                      .toISOString()
                      .slice(0, 10);
                    const formattedEndDate = endDate.toISOString().slice(0, 10);

                    return (
                      <tr
                        className="border border-slate-300 h-12"
                        key={campaign.communicationId}>
                        <td className="">
                          <div className="w-tableDate truncate pl-5 items-center">
                            {formattedStartDate}
                          </div>
                        </td>
                        <td className="">
                          <div className="w-tableDate truncate items-center align-middle">
                            {formattedEndDate}
                          </div>
                        </td>
                        <td className="">
                          <div className="w-subject  items-center align-middle line-clamp-2 mr-1">
                            {campaign.communicationNameEng}
                          </div>
                        </td>
                        <td className="">
                          <div className="w-subject  items-center align-middle line-clamp-2 mr-1">
                            {campaign.communicationNameHk}
                          </div>
                        </td>
                        <td className="">
                          <div className="w-subject  items-center align-middle line-clamp-2 mr-1">
                            {campaign.communicationNameCn}
                          </div>
                        </td>
                        <td className="">
                          <div className=" truncate items-center align-middle">
                            {campaign.isPin === "Y" ? (
                              <div className="w-6 text-ft-light">
                                <svg
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  viewBox="0 0 24 24"
                                  xmlns="http://www.w3.org/2000/svg"
                                  aria-hidden="true">
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M4.5 12.75l6 6 9-13.5"></path>
                                </svg>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </td>

                        <td className="cursor-pointer">
                          <a onClick={() => openEdit(campaign)}>
                            <Icon src="edit" color="primary" />
                          </a>
                        </td>
                        <td className="relative cursor-pointer">
                          <a
                            onClick={() =>
                              handleDelete(campaign.communicationId)
                            }>
                            <Icon src="delete" color="primary" />
                          </a>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <div className="flex items-center justify-between px-4 py-3 md:px-6">
            <div className="hidden md:flex md:flex-1 md:items-center md:justify-between">
              <div className="text-content">
                {pagination.totalNumberOfRecords === 0 ? (
                  <p className="text-sm text-gray-700">
                    {t("common.noRecord")}
                  </p>
                ) : (
                  <p className="text-sm text-gray-700">
                    {t("common.showPage1")}
                    <span className="font-medium"> {preResult}</span>{" "}
                    {t("common.showPage2")}{" "}
                    <span className="font-medium">{nextResult}</span>{" "}
                    {t("common.showPage3")}{" "}
                    <span className="font-medium">
                      {pagination.totalNumberOfRecords}
                    </span>{" "}
                    {t("common.showPage4")}
                  </p>
                )}
              </div>
              <div className="text-content">
                {pagination && pagination.totalNumberOfRecords > 0 && (
                  <Stack spacing={2}>
                    <Pagination
                      page={parseInt(pagination.pageNumber) + 1}
                      shape={"circular"}
                      count={
                        pagination.totalNumberOfRecords &&
                        pagination.pageSize &&
                        !isNaN(pagination.totalNumberOfRecords) &&
                        !isNaN(pagination.pageSize)
                          ? Math.ceil(
                              pagination.totalNumberOfRecords /
                                pagination.pageSize
                            )
                          : 0
                      }
                      onChange={(e, value) => handlePageChange(value)}
                    />
                  </Stack>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Communication;
